

jQuery(function ($) {
    if ($('.evenementen').length == 0) {
        return;
    }

    let postsContainer = $('.evenementen__results'); 

    function getUrlParameter(name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        let regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        let results = regex.exec(window.location.href);
        return results ? decodeURIComponent(results[1].replace(/\+/g, ' ')) : null;
    }

    let urlCategory = getUrlParameter('event-categorie');
    let initialCategories = postsContainer.data('cats') ? postsContainer.data('cats').toString().split(',') : [];
    let activeCategories = initialCategories;
    let activePosts = postsContainer.data('posts') ? postsContainer.data('posts').toString().split(',') : [];

    // If the URL contains a category, override the active categories
    if (urlCategory) {
        activeCategories = [urlCategory];
        
        // Mark the corresponding category as active
        $('.evenementen__categories .cat-item a').each(function() {
            let categorySlug = $(this).attr('href').split('/').filter(Boolean).pop();
            if (categorySlug === urlCategory) {
                $(this).parent().addClass('active');
            }
        });
    }

    function fetchPosts(categories, posts) {
        $.ajax({
            url: wemake.ajax_url, 
            type: 'POST',
            dataType: 'json',
            data: {
                action: 'filter_posts',
                categories: categories,
                posts: posts,
                post_type: 'event',
            },
            beforeSend: function () {
                postsContainer.html('<div class="spinner-loader"></div>'); 
            },
            success: function (data) {
                if (data.data) {
                    postsContainer.html(data.data); 
                } else {
                    postsContainer.html('<h4 class="t-center">Geen geplande activiteiten gevonden</h4>');
                }
            },
            error: function (xhr, status, error) {
                console.error('Error:', error);
            }
        });
    }

    // Handle category clicks for desktop
    $('.evenementen__categories .cat-item').on('click', function(e) {
        e.preventDefault();
        
        $(this).toggleClass('active'); // Toggle active class

        // Recalculate all active categories
        let selectedCategories = $('.evenementen__categories .cat-item.active').map(function() {
            return $(this).find('a').attr('href').split('/').filter(Boolean).pop();
        }).get();

        fetchPosts(selectedCategories.length > 0 ? selectedCategories : initialCategories, []); 
    });

    fetchPosts(activeCategories, activePosts);
});
